module.exports = __webpack_public_path__ + "img/2.618bfa98.png";